"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function Button(_a) {
    var label = _a.label, disabled = _a.disabled, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)("button", { disabled: disabled, className: "pure-button", onClick: onClick, children: label }));
}
exports.default = Button;
